function state() {
  return {
    organizations: [],
    organization: {},
    product_categories: [],
    template_role: [],
  };
}

export default state;
